import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { PreviewViewerService } from "ng/src/app/core/preview-viewer/preview-viewer.service";
import { fromEvent, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { Nullable } from "ng/src/app/shared/model/app.model";

@Component({
	templateUrl: './preview-viewer.component.html',
	styleUrls: ['./preview-viewer.component.scss'],
	selector: 'lb-preview-viewer'
})
export class PreviewViewerComponent implements OnInit, OnDestroy {
	@ViewChild('background') backgroundRef!: ElementRef;
	file: FileAttachment | null = null;
	time: Nullable<number> = null;
	
	private readonly onDestroy$ = new Subject();
	
	constructor(
		private previewViewerService: PreviewViewerService
	) {}
	
	ngOnInit(): void {
		this.previewViewerService.previewFile$.pipe(
			takeUntil(this.onDestroy$)
		)
			.subscribe(fa => {
				this.time = null;
				this.file = fa;
				this.toggleBodyOverflow(!!this.file);
			});
		
		fromEvent(window, 'keydown')
			.pipe(
				takeUntil(this.onDestroy$),
				filter(() => !!this.file)
			)
			.subscribe((ev) => {
				if ((ev as KeyboardEvent).key === 'Escape')
					this.clearFile();
			})
	}
	
	ngOnDestroy(): void {
		this.onDestroy$.next();
		this.toggleBodyOverflow(false);
	}
	
	clearFile() {
		this.previewViewerService.previewFile(null);
	}
	
	openInNewWindow() {
		if (!this.file) return;
		PreviewViewerService.previewInNewWindow(this.file, this.time ?? undefined);
		this.clearFile();
	}
	
	toggleBodyOverflow(hidden: boolean) {
		document.body.classList.toggle('p-overflow-hidden', hidden);
	}
	
	updatePlaybackTime(time: number) {
		this.time = time;
	}
}